export function closeAnnouncementBar() {
  const expiresDate = new Date();
  expiresDate.setTime(expiresDate.getTime() + 7 * 24 * 60 * 60 * 1000);
  let expiresValue = "expires=" + expiresDate.toUTCString();
  let closeValue = "announcementsbar=closed";
  let announcementbar = document.getElementById("announcement-bar-root");
  let barHTML = announcementbar.innerHTML;
  let encodebarHTML = encodeURIComponent(barHTML);
  let htmlValue = "htmlValue=" + encodebarHTML;
  document.cookie = closeValue + ";" + expiresValue + ";";
  document.cookie = htmlValue + ";" + expiresValue + ";";
  announcementbar.style.display = "none";
}

export function getCookie(key) {
  let name = key + "=";
  let cookieSplit = document.cookie.split(";");
  for (let i = 0; i < cookieSplit.length; i++) {
    let c = cookieSplit[i];
    while (c.charAt(0) == " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

export function checkBarCookie() {
  let previousHTML = getCookie("htmlValue");
  let announcementbar = document.getElementById("announcement-bar-root");

  let rawCurrentHTML = announcementbar.innerHTML;
  let currentHTML = encodeURIComponent(rawCurrentHTML);
  if (previousHTML != currentHTML) {
    document.cookie =
      "announcementsbar=;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
  } else {
    let closeValue = getCookie("announcementsbar");
    let expiresValue = getCookie("expires");
    let today = new Date();
    let todayUTC = today.toUTCString();
    if (closeValue == "closed" && expiresValue < todayUTC) {
      announcementbar.style.display = "none";
    }
  }
}
